import { SerialNumberTypeEnum } from '@ztechapps/common.contract'

export const serialNumberTypeOptions = [
  { label: 'Individual', value: SerialNumberTypeEnum.Individual },
  { label: 'Batch', value: SerialNumberTypeEnum.Batch },
]
